import React from 'react';
import './BlogSlider.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BlogSlider = () => {
  const blogPosts = [
    {
      id: 1,
      title: "The Future of Web Development",
      image: "https://via.placeholder.com/300",
      description: "Discover the trends shaping the web in 2024.",
    },
    {
      id: 2,
      title: "Why React is a Developer's Favorite",
      image: "https://via.placeholder.com/300",
      description: "A deep dive into why React dominates the front-end world.",
    },
    {
      id: 3,
      title: "How to Master Responsive Design",
      image: "https://via.placeholder.com/300",
      description: "Tips and tricks to make your designs truly responsive.",
    },
    {
      id: 4,
      title: "AI's Impact on Modern Design",
      image: "https://via.placeholder.com/300",
      description: "How AI tools are reshaping creative workflows.",
    },
  ];

  // Slick settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Show 3 cards side by side
    slidesToScroll: 1, // Slide one card at a time
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  

  return (
    <div className="blog-slider">
      <Slider {...settings}>
        {blogPosts.map((post) => (
          <div key={post.id} className="blog-card">
            <img src={post.image} alt={post.title} className="blog-image" />
            <h3 className="blog-title">{post.title}</h3>
            <p className="blog-description">{post.description}</p>
            <button className="read-more">Read More</button>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BlogSlider;
